import SecondaryActionButton from '../../../components/buttons/SecondaryActionButton';

type Props = {
  demandId: string;
  numberOfAttachments: number;
};

const DownloadAllAttachmentsButton = ({ demandId, numberOfAttachments }: Props) => {
  if (numberOfAttachments === 0) {
    return null;
  }
  return (
    <SecondaryActionButton
      href={`/api/demands/${demandId}/attachments`}
      dataTestId="download-btn"
      label="Télécharger"
    />
  );
};

export default DownloadAllAttachmentsButton;
